import { Component } from '@angular/core';

@Component({
  selector: 'app-subscription-icon',
  templateUrl: './subscription-icon.component.html',
  styleUrls: ['./subscription-icon.component.scss']
})
export class SubscriptionIconComponent {
  constructor() { }
}
